<!--
  The conversations, one row per contact per channel, newest first: the customer card's
  הודעות ומסרים tab, /messages and the header's whatsapp box. A click opens the conversation;
  activeMsgGroup marks the one open beside the list. The channel badge keeps its
  .whatsapp / .email class (the tests look for it).
-->
<template>
    <div class="chatConversationList"
         style="user-select:none;">

        <div class="multiMessageContact"
             :class="{ active: activeMsgGroup && message.msgGroup == activeMsgGroup }"
             @click="$emit('clicked', message)"
             v-for="(message, index) in messages"
             :key="message.msgGroup || index">

            <div class="multiMessageAvatar">

                <img :src="$handlers.customerHandler.getContactImage(message)"
                     @error="$handlers.customerHandler.onContactImageError($event, message)">

                <span class="multiMessageChannel"
                      :class="message.typeOfMessage"></span>

            </div>

            <div class="multiMessageContactAbout">

                <div class="multiMessageContactTop">

                    <div class="multiMessageContactName">
                        {{ $handlers.customerHandler.getDisplayName(message) }}
                    </div>

                    <div class="multiMessageContactTime">
                        {{ when(message.created) }}
                    </div>

                </div>

                <div class="multiMessageContactStatus">
                    {{ message.message }}
                </div>

            </div>

        </div>

    </div>
</template>
<script>

import { listWhen } from '@/helpers/chat-time';

export default {
    name: 'LatestPlanupMultiMessages',
    props: ['limit', 'customerId', 'customer', 'type', 'activeMsgGroup'],
    methods: {

        //today its time, yesterday "אתמול", before that the date
        when(created) {
            return listWhen(created);
        }

    },
    data() {


        this.$handlers.planupMultiMessagesHandler.getLatest(this.limit, this.customerId, this.type).then(messages => {

            if (this.customer) {
                messages.forEach(message => {

                    message.pic = this?.customer?.contacts?.find(contact => contact.id === message.contactId)?.pic;
                });
            }

            this.messages = messages.reverse();
            this.$emit('loaded', this.messages[0]);
        });



        return {
            messages: [],
        }

    }

}

</script>

<style>
.multiMessageContact {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 10px;
    margin-bottom: 2px;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    transition: background .15s;
}

.multiMessageContact:hover {
    background: #f6f7fb;
}

.multiMessageContact.active {
    background: #f1edfb;
}

.multiMessageAvatar {
    position: relative;
    flex: none;
    width: 46px;
    height: 46px;
}

.multiMessageAvatar img {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #eef0f6;
    display: block;
    background: #fff;
}

/* the badge itself is styled with the chat header's (.chatChannelBadge) in PlanupMultiMessagesChat */
.multiMessageChannel {
    width: 18px;
    height: 18px;
    font-size: 10px;
}

.multiMessageContactAbout {
    flex: 1 1 auto;
    min-width: 0;
}

.multiMessageContactTop {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
}

.multiMessageContactName {
    color: #2a3142;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.multiMessageContactTime {
    color: #9aa0ad;
    font-size: 11px;
    flex: none;
}

.multiMessageContactStatus {
    color: #8a90a0;
    font-size: 12px;
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
